import { object, string } from "yup";


const userEmailCharUppLimit = 50;
const passwordCharUppLimit = 20;
const passwordCharLowLimit = 6;


export const signInFormSchema = object().shape({
  email:string()
    .email(`Please enter a valid email`)
    .required("Email is required")
    .max(userEmailCharUppLimit, `Email cannot exceed ${userEmailCharUppLimit} characters.`),
  password: string()
    .required("Password is required")
    .min(passwordCharLowLimit, `Password must be at least ${passwordCharLowLimit} characters`)
    .max(passwordCharUppLimit, `Password cannot exceed ${passwordCharUppLimit} characters.`),
});